import { render, staticRenderFns } from "./VCAMenu.vue?vue&type=template&id=71f8494f&scoped=true&"
import script from "./VCAMenu.vue?vue&type=script&lang=ts&"
export * from "./VCAMenu.vue?vue&type=script&lang=ts&"
import style0 from "./VCAMenu.vue?vue&type=style&index=0&id=71f8494f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f8494f",
  null
  
)

export default component.exports